<template>
  <DossierDocumentCard
    title="Inscrição no Conselho Municipal da Pessoa Idosa (CMI / CMDPI)"
    :status-options="statusOptions"
    :multiple-status="true"
    :status-requires-validity="['possui_vigente', 'possui_provisorio']"
    :status-requires-upload="['possui_vigente', 'possui_provisorio']"
    :explainer-text="explainerText"
    :mode="mode"
    :not-applicable="false"
    :start-collapsed="startCollapsed"
    v-model="formData"
    save-endpoint="/rest-home/dossier/elderly-council"
    upload-endpoint="/rest-home/dossier/elderly-council/upload"
    @saved="onSaved"
    @error="onError"
    v-show="mode == 'view' ? formData.file_url : true"
  >
    <template #fields-before>
      <div class="dossier-module__fields">
        <!-- Nome do conselho (varia por município) -->
        <div class="dossier-module__field-group">
          <label class="dossier-module__label"
            >Nome do conselho no município</label
          >
          <v-text-field
            v-if="!isViewMode"
            v-model="formData.council_name"
            dense
            outlined
            hide-details
            placeholder="Ex: Conselho Municipal do Idoso de São Paulo"
            class="dossier-module__input"
          />
          <span v-else class="dossier-module__view-value">{{
            formData.council_name || "—"
          }}</span>
        </div>

        <!-- Número do registro / inscrição -->
        <div
          class="dossier-module__field-group dossier-module__field-group--small"
        >
          <label class="dossier-module__label">Número do registro</label>
          <v-text-field
            v-if="!isViewMode"
            v-model="formData.registration_number"
            dense
            outlined
            hide-details
            placeholder="Número da inscrição"
            class="dossier-module__input"
          />
          <span v-else class="dossier-module__view-value">{{
            formData.registration_number || "—"
          }}</span>
        </div>
      </div>
    </template>
  </DossierDocumentCard>
</template>

<script>
import DossierDocumentCard from "../dossier/DossierDocumentCard.vue";

const EXPLAINER_TEXT = `
  A inscrição no Conselho Municipal da Pessoa Idosa (CMI ou CMDPI, conforme o
  município) é o documento que formaliza o registro da ILPI junto ao órgão
  colegiado responsável pela fiscalização e defesa dos direitos da pessoa idosa.<br><br>
  A denominação e os requisitos variam por município. Consulte a Secretaria
  Municipal responsável para verificar a exigência e o processo de inscrição
  na sua cidade.<br><br>
  O Sistema Clin não valida o conteúdo do documento, apenas registra sua
  existência para fins de organização e apresentação à fiscalização.
`;

export default {
  name: "DossierElderlyCouncil",
  components: { DossierDocumentCard },
  props: {
    mode: {
      type: String,
      default: "edit",
      validator: (v) => ["edit", "view"].includes(v),
    },
    initialData: { type: Object, default: () => ({}) },
    startCollapsed: { type: Boolean, default: false },
  },
  data() {
    return {
      explainerText: EXPLAINER_TEXT,
      statusOptions: [
        { value: "possui_vigente", label: "Possui inscrição vigente" },
        { value: "possui_provisorio", label: "Possui inscrição provisória" },
        {
          value: "em_elaboracao",
          label: "Em processo de inscrição ou renovação",
        },
        { value: "nao_possui", label: "Não possui (pendente)" },
        { value: "nao_exigido", label: "Não exigido no município" },
      ],
      formData: {
        council_name: "",
        registration_number: "",
        status: [],
        validity_date: null,
        file_url: null,
        file_name: null,
        observations: "",
        ...this.flattenInitialData(),
      },
    };
  },
  computed: {
    isViewMode() {
      return this.mode === "view";
    },
  },
  watch: {
    initialData: {
      deep: true,
      handler() {
        Object.assign(this.formData, this.flattenInitialData());
      },
    },
  },
  methods: {
    flattenInitialData() {
      const d = this.initialData || {};
      return {
        council_name: d.council_name || "",
        registration_number: d.registration_number || "",
        status: d.status || [],
        validity_date: d.validity_date || null,
        file_url: d.file_url || null,
        file_name: d.file_name || null,
        observations: d.observations || "",
      };
    },
    onSaved(data) {
      this.$emit("saved", { module: "elderly_council", data });
    },
    onError(errors) {
      this.$emit("error", { module: "elderly_council", errors });
    },
  },
};
</script>